import { getValidToken } from '../utils/tokenUtils';

export const fetchReviewerDecisionQueue = async (includeHandled = false) => {
  const token = await getValidToken();

  if (!token) {
    throw new Error('No valid authentication token available');
  }

  const params = new URLSearchParams({
    includeHandled: includeHandled ? 'true' : 'false',
  });

  const res = await fetch(`/api/reviewer/decision-queue?${params.toString()}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    const text = await res.text().catch(() => null);
    const err = new Error(`Failed to fetch reviewer decision queue: ${res.status}` + (text ? ` - ${text}` : ''));
    err.status = res.status;
    throw err;
  }

  return res.json();
};

export const executeReviewerDecision = async (deviationId, payload = {}) => {
  if (!deviationId && deviationId !== 0) {
    throw new Error('deviationId is required');
  }

  const token = await getValidToken();

  if (!token) {
    throw new Error('No valid authentication token available');
  }

  const res = await fetch(`/api/reviewer/decision-queue/${encodeURIComponent(deviationId)}/execute`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => null);
    const err = new Error(`Failed to execute reviewer decision: ${res.status}` + (text ? ` - ${text}` : ''));
    err.status = res.status;
    throw err;
  }

  return res.json();
};
